// Menu top-level "Pedidos" (antes submenu de Operações) e "Aprovações"
// (antes botão dentro da listagem — agora menu próprio, só Supervisor/Admins).
export function getPedidosNav() {
  return [
    {
      title: 'Pedidos',
      route: 'pedidos-vendas',
      icon: 'ShoppingCartIcon',
      action: 'read',
      resource: 'PedidosVenda',
    },
    {
      title: 'Aprovações',
      route: 'pedidos-vendas-aprovacoes',
      icon: 'CheckCircleIcon',
      action: 'read',
      resource: 'PedidosAprovacao',
      explicitModule: true,
    },
  ];
}

export default getPedidosNav();
